import { Typography, Tooltip } from "@mui/material";
import { TypographyProps } from "@mui/material/Typography";
import {
  relativeTime,
  absoluteTime,
  dateObjectToshortDatetime,
} from "../../common/utils";

export default ({
  date,
  variant = "bodySmall",
  color = "textSecondary",
  tooltipEnabled = true,
  sx,
  useRelativeAsPrimary = true,
}: {
  date: Date;
  variant?: TypographyProps["variant"];
  color?: string;
  tooltipEnabled?: boolean;
  sx?: React.CSSProperties;
  useRelativeAsPrimary?: boolean;
}) => {
  const absTime = absoluteTime(date);

  const content = (
    <Typography variant={variant} color={color} sx={{ ...sx }}>
      {useRelativeAsPrimary
        ? relativeTime(date)
        : dateObjectToshortDatetime(date)}
    </Typography>
  );

  return tooltipEnabled ? (
    <Tooltip
      title={absTime}
      placement="top"
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -10],
            },
          },
        ],
      }}
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
};
